import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { computed, ComputedRef } from "vue"

// Enums
import { PaymentCondition } from "@/enums/paymentCondition"

// Components
import FlexiblePaymentCondition from "./FlexiblePaymentCondition.vue"
import FixedPaymentCondition from "./FixedPaymentCondition.vue"

import { useStore } from "vuex"
interface Props {
	paymentCondition: number
	displayTitle: boolean
	cancellationDate: string
	/** PV only: "flex" | "nonflex". Absent for non-PV → use paymentCondition. */
	pvFlex?: string
	prestId?: string
	isDisplayPlaceholders?: boolean
	isCompactDisplay?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentCondition',
  props: {
    paymentCondition: {},
    displayTitle: { type: Boolean },
    cancellationDate: {},
    pvFlex: {},
    prestId: {},
    isDisplayPlaceholders: { type: Boolean },
    isCompactDisplay: { type: Boolean }
  },
  setup(__props: any) {

const store = useStore();

// Props
const props = __props

// Computed
const startDate: ComputedRef<string> = computed(() => {
	return store.state.dates.BeginDate || ""
})

const isPVFlexProduct: ComputedRef<boolean> = computed(() => {
	return props.pvFlex === "flex"
})

// PV: FLEX/FIXE comes from pvFlex (API often sends paymentCondition=2 for both).
// Non-PV: use paymentCondition (1 = FLEX, 2 = FIXE).
const showFlexible: ComputedRef<boolean> = computed(() => {
	if (props.pvFlex === "flex") return true
	if (props.pvFlex === "nonflex") return false
	return props.paymentCondition === PaymentCondition.FLEXIBLE
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (showFlexible.value)
      ? (_openBlock(), _createBlock(FlexiblePaymentCondition, {
          key: 0,
          displayTitle: props.displayTitle,
          prestId: props.prestId,
          isPVFlex: isPVFlexProduct.value,
          isDisplayPlaceholders: props.isDisplayPlaceholders,
          content: _unref(store).state.content,
          cancellationDate: props.cancellationDate,
          startDate: startDate.value,
          isCompactDisplay: props.isCompactDisplay
        }, null, 8, ["displayTitle", "prestId", "isPVFlex", "isDisplayPlaceholders", "content", "cancellationDate", "startDate", "isCompactDisplay"]))
      : (_openBlock(), _createBlock(FixedPaymentCondition, {
          key: 1,
          displayTitle: props.displayTitle,
          prestId: props.prestId,
          isDisplayPlaceholders: props.isDisplayPlaceholders,
          content: _unref(store).state.content,
          isCompactDisplay: props.isCompactDisplay
        }, null, 8, ["displayTitle", "prestId", "isDisplayPlaceholders", "content", "isCompactDisplay"]))
  ]))
}
}

})